module.exports = __webpack_public_path__ + "static/banner-1-718a3daa93efe63a0d70277142f52e39.png";